/**
 * Promo Badge Web Component
 * Handles date-based validation for promotional badges
 * Displays badge below price if within scheduled time window
 */
class PromoBadgeComponent extends HTMLElement {
  static get observedAttributes() {
    return ['data-product-id'];
  }

  connectedCallback() {
    this.init();
  }

  /**
   * @param {string} name
   * @param {string | null} oldValue
   * @param {string | null} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    // Re-init when product-id changes (morph updates this attribute)
    // Use setTimeout to run AFTER morph finishes updating children
    if (oldValue !== null && oldValue !== newValue) {
      setTimeout(() => this.init(), 0);
    }
  }

  init() {
    const hasDates = this.dataset.hasDates === 'true';

    // No date validation needed - badge is always active
    if (!hasDates) {
      const content = this.querySelector('[data-promo-content]');
      if (content) {
        content.setAttribute('data-active', 'true');
      }
      return;
    }

    // Perform date validation
    this.validateDates();
  }

  validateDates() {
    const startDateUnix = this.dataset.startDate ? parseInt(this.dataset.startDate) : null;
    const endDateUnix = this.dataset.endDate ? parseInt(this.dataset.endDate) : null;
    const nowUnix = Math.floor(Date.now() / 1000);

    let isValid = true;

    // Check start date (if provided)
    if (startDateUnix && nowUnix < startDateUnix) {
      isValid = false;
    }

    // Check end date (if provided)
    if (endDateUnix && nowUnix > endDateUnix) {
      isValid = false;
    }

    // Update visibility using data attributes
    const content = this.querySelector('[data-promo-content]');
    const fallback = this.querySelector('[data-promo-fallback]');

    if (isValid) {
      if (content) {
        content.setAttribute('data-active', 'true');
        content.removeAttribute('hidden');
      }
      if (fallback) {
        fallback.setAttribute('hidden', '');
      }
    } else {
      if (content) {
        content.removeAttribute('data-active');
        content.setAttribute('hidden', '');
      }
      if (fallback) {
        fallback.removeAttribute('hidden');
      }
    }
  }
}

// Register custom element
if (!customElements.get('promo-badge-component')) {
  customElements.define('promo-badge-component', PromoBadgeComponent);
}

